import { ModalProps } from "antd/lib/modal/Modal";
import { Col, Modal, Row } from "antd";
import styles from "./index.module.scss";
import React, { useImperativeHandle, useState } from "react";
import { ChapterTree } from "../../../../../../service/CourseDetail/chapter";
import ChapterSelect from "../../../../../../components/ChapterSelect";
import lodash from "lodash-es";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

export interface TargetProps {
    targetKey: string; //发生的真实点击的key
}
export interface moveProps extends TargetProps {
    nodeId: string;
}
interface DataModalProps extends ModalProps {
    onSuccess: (payload: moveProps) => void;
    onCancel?: () => void;
    treeData: ChapterTree[];
}

const DataModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onCancel, treeData, ...props }, ref) => {
        const [payload, setPayload] = useState<ChapterTree>({
            key: "",
            chapterCode: "",
            chapterName: "",
            chapterSort: 0,
            children: [],
            dcCourseChapterEntity: {
                batchNo: undefined,
                courseNo: "",
                courseSeq: ""
            },
            dcCoursewareSourceList: [],
            id: 0,
            level: 0,
            parentId: 0
        });
        const [targetKey, setTargetKey] = useState("");
        useImperativeHandle(ref, () => ({
            setPayload: ({ payload, targetKey }) => {
                setPayload(payload);
                setTargetKey(targetKey);
            }
        }));

        const [nodeId, setNodeId] = useState("0");

        return (
            <Modal
                {...props}
                className={styles.root}
                onCancel={onCancel}
                maskClosable={false}
                title="移动"
                onOk={() => onSuccess?.({ nodeId, targetKey })}>
                <div style={{ padding: "30px 0" }}>
                    <Row type="flex" align="middle" gutter={15}>
                        <Col span={7}>
                            <div style={{ textAlign: "right" }}>所属父级：</div>
                        </Col>
                        <Col span={15}>
                            <ChapterSelect
                                targetKey={targetKey}
                                clickData={
                                    payload ? lodash.cloneDeep([payload]) : null
                                }
                                value={nodeId}
                                onChange={setNodeId}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
        );
    }
);

export default DataModal;
